import { Stack } from '@mui/material';
import { useShallow } from 'zustand/react/shallow';

import { AvatarCircle } from '@src/components';
import { WhiteRaisedHandLabel } from '@src/assets/icons';
import { ParticipantsActionsMenu } from '@src/components/ParticipantsList/partials';
import useParticipantsList from '@src/components/ParticipantsList/useParticipantsList';

import { BiDotsHorizontalRounded } from 'react-icons/bi';
import { BsCameraVideo, BsCameraVideoOffFill, BsMic, BsMicMuteFill } from 'react-icons/bs';

import { usePeersStore, useRoomStore } from '@src/stores';
import { toKFormat } from '@src/utils';

import { EUserType } from '@src/types';

import './Participants.scss';
interface IParticipantsProps {
  onHideSheet: () => void;
}

const Participants = ({ onHideSheet }: IParticipantsProps) => {
  const { participantsPeers, handleMuteParticipant, currentPeer } = useParticipantsList();
  const { viewersCount } = usePeersStore(
    useShallow((state) => ({
      viewersCount: state.viewersCount,
    }))
  );

  const { meetingType } = useRoomStore(
    useShallow((state) => ({
      meetingType: state.meetingType,
    }))
  );

  return (
    <Stack
      gap={2}
      className="participants-mobile"
      onPointerDown={(e) => {
        e.stopPropagation();
      }}
      id="participants-mobile"
    >
      <p>
        {meetingType !== 'webinar' || currentPeer?.peer_info.user_type === EUserType.ATTENDEE
          ? `Attendees (${participantsPeers.length})`
          : `Viewers - (${toKFormat(Number(viewersCount))}) | Panellists - (${participantsPeers.length})`}
      </p>

      {!!participantsPeers.length &&
        participantsPeers.map((participant) => {
          if (!participant) return null;
          const {
            peer_info: { peer_id, peer_name: peerName, peer_audio, peer_video },
            handRaiseOrder,
            isMe,
          } = participant;

          return (
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              className="participants-mobile__row"
              key={peer_id}
              onPointerDown={(e) => {
                e.stopPropagation();
              }}
              id="participants-mobile-row"
            >
              <Stack direction="row" alignItems="center" justifyContent="center" gap="10px" className="participant">
                <div className="img-container">
                  <AvatarCircle peerId={peer_id} avatarImgSize={36} />
                  {handRaiseOrder && (
                    <>
                      <span className="hand-order-mob">{handRaiseOrder}</span>
                      <WhiteRaisedHandLabel className="hand-mob" />
                    </>
                  )}
                </div>
                <span className="participant__name">{peerName + (isMe ? ' (Me)' : '')}</span>
              </Stack>
              <Stack direction="row" justifyContent="start" gap="10px" className="actions-container">
                <div
                  className={`icon-container ${!peer_audio ? 'closed ' : ''}`}
                  onClick={() => handleMuteParticipant(peer_id)}
                >
                  {!peer_audio ? <BsMicMuteFill /> : <BsMic />}
                </div>
                <div className={`icon-container ${!peer_video ? 'closed ' : ''}`}>
                  {!peer_video ? <BsCameraVideoOffFill /> : <BsCameraVideo />}
                </div>
                {!isMe && (
                  <div className="icon-container">
                    <ParticipantsActionsMenu
                      participant={participant}
                      onHideSheet={onHideSheet}
                      iconButton={
                        <div className="icon-container">
                          <BiDotsHorizontalRounded size={24} />
                        </div>
                      }
                    />
                  </div>
                )}
              </Stack>
            </Stack>
          );
        })}
    </Stack>
  );
};

export default Participants;
